<template>
    <div class="w-full">
        <visual-type-graph-squares
            position="top"
            heading="Extraversion"
            :visual_types="visual_types"
            :total="total"
        />

        <visual-type-graph-squares
            position="bottom"
            heading="Introversion"
            :visual_types="visual_types"
            :total="total"
        />
    </div>
</template>

<script>
import VisualTypeGraphSquares from './visual-type-graph-squares.vue';

export default {
    components: {
        VisualTypeGraphSquares,
    },

    props: {
        visual_types: {},
    },

    computed: {
        total() {
            return Object.values(this.visual_types)
                .reduce((sum, visual_type) => sum + (visual_type.value || 0), 0);
        },
    },
}
</script>
